import {Injectable} from '@angular/core';
import {Headers, Http, RequestOptions, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';

import {ContentUsage, Dialog} from 'classes/dialog';
import {environment} from 'environment';

import {TargetGroup} from 'shared/models/target-groups/target-group';

@Injectable()
export class DialogsOverviewRepository {

  constructor(private http: Http) { }

  public getAllDialogs(): Observable<Array<Dialog>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});
    return this.http.get(environment.dialogs, options)
      .map((response: Response) => {
        return response.json();
      })
      .map((rawDialogs: Array<Dialog>) => {
        return this.mapToDialogs(rawDialogs);
      });
  }

  public getAllTargetGroups(): Observable<Array<TargetGroup>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.targetGroups.targetGroups}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public deleteDialog(id: string): Observable<Response> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});
    return this.http.delete(`${environment.dialogs}/${id}`, options);
  }

  private mapToDialogs(rawDialogs: Array<Dialog>): Array<Dialog> {
    return rawDialogs.map((rawDialog) => {
      return Dialog.create(rawDialog);
    });
  }

  public cloneDialogs(dialogIds: Array<String>, targetGroupId: String, deltaDays: String): Observable<Array<Dialog>>  {
     const headers: Headers = new Headers({'Content-Type': 'application/json'});
     const options: RequestOptions = new RequestOptions({headers: headers, withCredentials: true});
     const body = JSON.stringify({
       dialogIds: dialogIds,
       targetGroupId: targetGroupId,
       deltaDays: deltaDays,
     });

     return this.http.post(environment.dialogsClone, body, options)
      .map((response: Response) => {
        return response.json();
      })
      .map((rawDialogs: Array<Dialog>) => {
        return this.mapToDialogs(rawDialogs);
      });
  }

  public getContentUsages(id: string): Observable<Array<ContentUsage>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.contents}/usageDialog/${id}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/dialogs/dialogs-overview/repositories/dialogs-overview.repository.ts